import React from 'react';
import DropdownMenuText from './DropdownMenuText'; // Importing DropdownMenuText component
import DropdownMenuBox from './DropdownMenuBox'; // Importing DropdownMenuBox component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Importing FontAwesomeIcon for icons

// DropDown component to render a dropdown menu with options
const DropDown = ({ 
  menu, 
  header, 
  bgStyle, 
  styleType, 
  filterType, 
  showBox, 
  showList, 
  onUpdate, 
  onToggle, 
  styleData 
}) => {
  
  return (
    <div className='dropdown__wrapper' onClick={() => onToggle(menu.id)}> {/* Wrapper for the dropdown that triggers toggle on click */}
      <div className={`dropdown__top ${menu.selected ? 'dropdown__bottom__selected' : ''}`} style={{borderColor: styleData.web_main_color}}> {/* Dropdown top section */}
        <div className='dropdown-header-cont'>
          <div className={`dropdown__box ${showBox && (styleType === menu.key && styleType !== 'price') ? 'd-block' : 'd-none'}`} style={bgStyle}></div> {/* Conditional box for dropdown */}
          <span className='dropdown__text' style={{color: styleData.web_main_color}}>{header}</span> {/* Dropdown header text */}
        </div>
        <FontAwesomeIcon icon="fa-solid fa-chevron-down" color={styleData.web_main_color} size='xl' /> {/* Dropdown icon */}
      </div>
      <div className={`dropdown__bottom ${filterType === menu.key && showList ? 'd-block' : 'd-none'}`} style={{borderColor: styleData.web_main_color}}> {/* Dropdown bottom section for options */}
        {/* Render different types of dropdown menus based on menuType */}
        {menu.menuType === 'text' 
          ? <DropdownMenuText menu={menu.menu} onSelect={(item) => onUpdate(item, menu)} styleData={styleData} /> 
          : menu.menuType === 'box' 
          ? <DropdownMenuBox menu={menu.menu} onSelect={(item) => onUpdate(item, menu)} /> 
          : ''
        }
      </div>
    </div>
  )
}

export default React.memo(DropDown); // Export the DropDown component, wrapped in React.memo for performance optimization
